import { createStore } from "vuex";
// 然后给 actions 注册一个事件处理函数，当这个函数被触发时，将状态提交到 mutaions中处理
import actions from "./actions";
// 更新状态
import mutations from "./muations";
// 获取状态信息
import getters from "./getters";

// 首先声明一个状态 state
const state = {
  //全局loading配置
  loadingObj: null,
  //用户信息
  userData: null,
  isInofMengBan: false, //蒙版
  AllDomItem: {}, //接口获取的所有点位
  listState: ["9000001", "9000003", "9000002", "9000004", "9000005"], //存储点击的菜单编号
  typeDomNameMoldAll: [
    {
      number: null,
      name: null,
      url: require("@/assets/homePage/livestreaming1.png"),
      clickUrl: require("@/assets/homePage/livestreaming1.png"),
      popype: "manage",
      info: true, //是否显示
      markerName: "路况",
      legendIcon: require("@/assets/mapIcon/路况.png"),
      makerIcon: require("@/assets/homePage/roadCondition.png"),
    }, //路况
    {
      number: "9000001",
      name: "自定义地图10",
      url: require("@/assets/homePage/accident2.png"),
      clickUrl: require("@/assets/homePage/accident2.png"),
      legendIcon: require("@/assets/mapIcon/突发.png"),
      makerIcon: require("@/assets/homePage/accident.png"),
      popype: "interdict",
      info: false,
      markerName: "阻断",
    }, //阻断
    {
      number: "9000003",
      name: "自定义地图13",
      url: require("@/assets/homePage/construction2.png"),
      clickUrl: require("@/assets/homePage/construction2.png"),
      legendIcon: require("@/assets/mapIcon/施工.png"),
      makerIcon: require("@/assets/homePage/construction.png"),
      popype: "tunnel",
      info: false,
      markerName: "施工",
    }, //施工
    {
      number: "9000004",
      name: "自定义地图16",
      url: require("@/assets/homePage/fwq.png"),
      clickUrl: require("@/assets/homePage/fwq.png"),
      legendIcon: require("@/assets/mapIcon/服务区.png"),
      makerIcon: require("@/assets/homePage/serviceAre.png"),
      popype: "bridge",
      info: false,
      markerName: "服务区",
    }, //服务区
    {
      number: "9000005",
      name: "自定义地图14",
      url: require("@/assets/homePage/sfz.png"),
      clickUrl: require("@/assets/homePage/sfz.png"),
      legendIcon: require("@/assets/mapIcon/收费站.png"),
      makerIcon: require("@/assets/homePage/tollstation.png"),
      popype: "service",
      info: false,
      markerName: "收费站",
    }, //收费站
    // {
    //   number: "9000002",
    //   name: "自定义地图11",
    //   url: require("@/assets/homePage/livestreaming1.png"),
    //   clickUrl: require("@/assets/homePage/dong.png"),
    //   popype: "cctv",
    //   info: true, //是否显示
    //   markerName: "直播",
    //   legendIcon: require("@/assets/homePage/livestreaming-close.png"),
    //   legendIcon1: require("@/assets/mapIcon/icon-cctv-off.svg"),
    //   makerIcon: require("@/assets/homePage/livestreaming.png"),
    // }, //摄像头
    {
      number: "9100002",
      name: "自定义地图1",
      url: require("@/assets/homePage/道路视频.png"),
      clickUrl: require("@/assets/homePage/道路监控.png"),
      popype: "cctv",
      info: true, //是否显示
      markerName: "路段",
      legendIcon: require("@/assets/mapIcon/监控.png"),
      makerIcon: require("@/assets/homePage/收费站.png"),
    }, //摄像头
    {
      number: "9500002",
      name: "自定义地图2",
      url: require("@/assets/homePage/收费站视频@2x.png"),
      clickUrl: require("@/assets/homePage/收费站监控.png"),
      popype: "cctv",
      info: true, //是否显示
      markerName: "收费站",
      legendIcon: require("@/assets/mapIcon/收费站.png"),
      makerIcon: require("@/assets/homePage/服务区1.png"),
    }, //摄像头
    {
      number: "9600002",
      name: "自定义地图3",
      url: require("@/assets/homePage/服务区视频@2x.png"),
      clickUrl: require("@/assets/homePage/服务区监控.png"),
      popype: "cctv",
      info: true, //是否显示
      markerName: "服务区",
      legendIcon: require("@/assets/mapIcon/服务区.png"),
      makerIcon: require("@/assets/homePage/收费站1.png"),
    }, //摄像头
  ], //点位信息和控制在这里
  mapModeList: [
    {
      name: "经典地图",
      legendIcon1: require("@/assets/homePage/map-backup-open.png"),
      legendIcon: require("@/assets/homePage/map-backup-close.png"),
      info: true,
      isAct: true,
      menu: "Classics",
    },
    {
      name: "简图模式",
      legendIcon1: require("@/assets/homePage/diagram-closes.png"),
      legendIcon: require("@/assets/homePage/diagrams.png"),
      info: false, //一上来  这里是true
      isAct: true, // 是否展示到列表
      menu: "Diagram", //简图
    },
    // {
    //   name: "深色地图",
    //   legendIcon: require("@/assets/homePage/dark-map-open.png"),
    //   legendIcon1: require("@/assets/homePage/dark-map-close.png"),
    //   info: false,
    //   isAct: true,
    //   menu: "Dark",
    // },
    {
      name: "天气地图",
      legendIcon1: require("@/assets/homePage/diagram-open.png"),
      legendIcon: require("@/assets/homePage/diagram-close.png"),
      info: false,
      isAct: true,
      menu: "weather",
    },
    {
      name: "地图选点",
      legendIcon1: require("@/assets/homePage/diagram-open.png"),
      legendIcon: require("@/assets/homePage/diagram-close.png"),
      info: false,
      isAct: false,
      menu: "selectionPoint",
    },
  ], //控制菜单选择的图层
  myLngLat: {
    // lng: 104.075931,
    // lat: 30.651651,
    lng: null,
    lat: null,
  }, //默认的经纬度
  gaudMapDom: null, //高德地图组件
  // userData:{openid: "ofw7W01l0txBMIQcUwXSZPXw1NGo"},//微信环境
  // userData:{openid: "BBDE6C87-E900-5A71-31CD-9BD9E7A1F895"},//app环境
  navigationList: [], //选择路段信息
  roadInformation: [], //选择路段的费用通信信息
  cameraIdAll: {}, //用id 來顯示的點位數據
  navigationData: false,
  RoutePlanning: {
    from: {
      name: "天府广场",
    },
    to: {
      name: "昆明市",
    },
  }, //发请求的选中的路段信息
  Collection: false, //出行导航详情页判断是否收藏的数据
  navigationIdexDetail: {},
  //小图标集合
  smallListUrl: {
    1: require("@/assets/travel/zhibo.png"), //直播
    3: require("@/assets/travel/lu.png"), //录播
    2: require("@/assets/travel/hui.png"), // 回放
    eye: require("@/assets/travel/yan.png"), //眼睛
    labagonggao: require("@/assets/travel/labagonggao.png"), //小喇叭
  },

  myPosition: {
    formattedAddress: "暂未用户定位",
    lnglat: ["", ""],
  },
};

export default createStore({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {},
});
